import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormContext, FormErrorTypes } from 'dash-ui';
import { isUrlValid, isEmptyOrNil, isNameLengthValid, DashValidation } from 'dash-common';

import { SaveSaleFormFields } from 'pages/external-sales/external-sale-teams/constants';

export const useSaveExternalTeamFormValidation = () => {
  const { errorHandlers, formState, setFormValues } = useContext(FormContext);
  const [isError, setIsError] = useState(false);
  const { t } = useTranslation('forms');
  const isValueExist = !!formState.name;

  const validate = (field: SaveSaleFormFields, value: string) => {
    switch (field) {
      case SaveSaleFormFields.Name: {
        if (isEmptyOrNil(value)) {
          setIsError(true);
          return errorHandlers[field]({
            type: FormErrorTypes.Invalid,
            message: t('messages.nameBlank'),
          });
        }
        if (!isNameLengthValid(value)) {
          setIsError(true);
          return errorHandlers[field]({
            type: FormErrorTypes.Invalid,
            message: t('forms:messages.maxCharacterLimit', {
              number: DashValidation.MaxNameLength.toString(),
            }),
          });
        }
        setIsError(false);
        errorHandlers[field](null);
        break;
      }
      case SaveSaleFormFields.Url: {
        if (value && !isUrlValid(value)) {
          setIsError(true);
          return errorHandlers[field]({
            type: FormErrorTypes.Invalid,
            message: t('messages.urlInvalid'),
          });
        }
        setIsError(false);
        errorHandlers[field](null);
        break;
      }
      default: {
        setIsError(false);
        errorHandlers[field](null);
      }
    }
  };

  return { validate, isError: isError || !isValueExist, setFormValues };
};
